import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-article-icon',
  templateUrl: './text-article.component.html'
})
export class TextArticleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
